<template>
  <v-autocomplete
    v-model="inputTag"
    :label="label"
    :items="selectableParentTags"
    :loading="isLoading"
    :search-input.sync="searchQuery.id_or_name_cont"
    item-text="name"
    item-value="id"
    hide-selected
    return-object
    clearable
    :disabled="disabled"
    :filter="filter"
    @click:clear="setTag(null)"
    @change="setTag"
  >
    <template v-slot:no-data>
      <v-list-item v-if="!searchQuery.id_or_name_cont"
        >タグ名を入力してください</v-list-item
      >
      <v-list-item v-else-if="isLoading">
        <v-list-item-title class="text-center">
          <v-progress-circular
            indeterminate
            color="blue-grey"
          ></v-progress-circular>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-else>
        <v-list-item-title> 見つかりませんでした </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'TagSelector',
  props: {
    tag: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'タグ'
    },
    filter: {
      type: Function,
      default: () => true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      debounceFetch: null,
      selectableParentTags: [],
      isLoading: false,
      inputTag: this.tag,
      searchQuery: { id_or_name_cont: this.tag ? this.tag.name : '' }
    }
  },
  watch: {
    'searchQuery.id_or_name_cont': function (val) {
      if (!val) {
        this.isLoading = false
        this.selectableParentTags = []
        this.debounceFetch.cancel()
      }

      this.isLoading = true
      this.debounceFetch()
    },
    tag (value) {
      this.inputTag = value
      this.syncTag(this.tag)
    }
  },
  mounted () {
    this.debounceFetch = _.debounce(this.fetchSelectableTag, 500)
    this.syncTag(this.tag)
  },
  methods: {
    fetchSelectableTag () {
      if (!this.searchQuery.id_or_name_cont) {
        this.isLoading = false
        return
      }

      this.selectableParentTags = this.inputTag ? [this.inputTag] : []
      axios
        .get('/api/tags', {
          params: { q: this.searchQuery },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(
          ({ data }) => {
            data.data.forEach(({ attributes }) => {
              if (!this.tag || attributes.id !== this.tag.id) {
                this.selectableParentTags.push(attributes)
              }
            })
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => (this.isLoading = false))
    },
    setTag (value) {
      this.$emit('change-tag', value)
    },
    syncTag (tagValue) {
      if (!tagValue || this.includeSelectableTags(tagValue)) {
        return
      }
      this.selectableParentTags.push(tagValue)
    },
    includeSelectableTags (tagValue) {
      return !!this.selectableParentTags.find((item) => item.id === tagValue.id)
    }
  }
}
</script>
